import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { toggleOurServiceModal } from "@/reducers/clientcommon";

const BlurredText = ({ type, blurKey = 1, children }) => {
  // console.log("blurKey---->", blurKey)
  const { isPremiumAccount } = useSelector((state) => state.session);
  const dispatch = useDispatch();
  if (isPremiumAccount && blurKey !== 0) {
    return children;
  }
  let content = "applocum";
  if (type === "email") {
    content = "appuser@access.com";
  } else if (type === "phone") {
    content = "12 1234 1234";
  } else if (type === "address") {
    content = "1234 Street, City, Country, 1234";
  }
  return (
    <span
      className="block cursor-pointer select-none font-thin blur-[4px]"
      onClick={() => {
        if (blurKey == 0) {
          return;
          // showCandidateSixMonthDurationToast();
        } else {
          dispatch(toggleOurServiceModal(true));
          // showManagedServiceToast()
        }
      }}
    >
      {content}
    </span>
  );
};

export default BlurredText;
